// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d-f[data-v-12994d4a]{display:flex;justify-content:space-between;flex-wrap:wrap;flex-direction:row}.m-8[data-v-12994d4a]{width:3.125rem;margin:0 0 20rpx 0}.f-w[data-v-12994d4a]{margin-top:.625rem}.btn[data-v-12994d4a]{margin-top:2.8125rem;margin-left:39%}", ""]);
// Exports
module.exports = exports;
